<template>
	<div>
		<div class="data17">
			<div class="data17Til">{{list.data.menuTitle}}</div>
			<div class="data17Cen">
				<div v-for="(item,index) in list.data.desc" :key="index">{{item.text}}</div>
			</div>
			<div class="dataImg">
				<template v-if="headerShow">
					<div class="dataImgBox" :style="{
					marginLeft:itema.title?`calc(650px - ${lista.length*82}px - 200px)`:`calc(650px - ${lista.length*82}px)`
				}">
						<!-- transform:indexa==index?'rotateY(15deg) scale(0.9)':'perspective(1000px) rotateY(30deg) scale(0.8)' -->
						<img :src="item.banner_cover" class="img" :style="{
				  '--img':(index*82+item.left)+'px',
				  zIndex:index==indexa?'99':'-1',
				 
			  }" v-for="(item,index) in lista" :key="index" @mouseenter="mouseover(index)" @mouseleave="mouseout" />
						<div class="dataImgDw" :style="{
				  '--img':(indexa*82+itema.left)+'px',
			  }">

							<!-- opacity:itema.title?1:0 -->
							<div class="dataImgDwXian" v-if="itema.banner_text">

							</div>
							<div class="dataImgDwWz">
								{{itema.banner_text}}
							</div>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="dataImgBox" :style="{
					marginLeft:itema.title?`calc(100% - ${lista.length*56}px - 50px)`:`calc(100% - ${lista.length*68}px)`
				}">
						<img :src="item.banner_cover" class="img" :style="{'--img':(index*30+item.left)+'px',zIndex:index==indexa?'99':'-1',}" v-for="(item,index) in lista" :key="index" @mouseenter="mouseover(index)" @mouseleave="mouseout" />
						<div class="dataImgDw" :style="{'--img':(indexa*30+itema.left)+'px',}">
							<div class="dataImgDwXian" v-if="itema.banner_text"></div>
							<div class="dataImgDwWz">
								{{itema.banner_text}}
							</div>
						</div>
					</div>
				</template>
				<template v-if="headerShow">
					<div class="csBoxRight" :style="{
						width:itema.title?'300px':0,
						opacity:itema.title?1:0
					}">
						<div class="csBoxRightTitle">
							{{itema.title}}
						</div>
						<div class="csBoxRightTitleTwo">
							{{itema.sub_title}}
						</div>
						<div class="csBoxRightCen">
							{{itema.desc}}
						</div>
						<div class="csBoxRightImg">
							<img :src="itema.cover" v-if="itema.cover" />
						</div>
					</div>
				</template>

			</div>
			<template v-if="!headerShow">
				<div class="csBoxRight" :style="{
					width:itema.title?'300px':0,
					opacity:itema.title?1:0,
					display:itema.title?'block':'none'
				}">
					<div class="csBoxRightTitle">
						{{itema.title}}
					</div>
					<div class="csBoxRightTitleTwo">
						{{itema.sub_title}}
					</div>
					<div class="csBoxRightCen">
						{{itema.desc}}
					</div>
					<div class="csBoxRightImg">
						<img :src="itema.cover" v-if="itema.cover" />
					</div>
				</div>
			</template>
			<!-- <div class="data17Img">
			<div class="swiper-data2-banner">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in list.data.videos" :key="index">
						<video :src="item"  :autoplay="true" muted loop></video>
					</div>
				</div>
			</div>
		</div> -->
			<div class="data17ImgList">
				<div class="swiper-canpin" :class="`swiper-canpin${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide swiper-slide-Two" v-for="(item,index) in list.data.covers" :key="index"
							:style="list.data.covers.length<4?'width: 375px':'width: 277px'">
							<div class="data17ImgListFor"
								:style="list.data.covers.length<4?'width: 375px':'width: 277px'">
								<img :src="item" :style="list.data.covers.length<4?'width: 375px':'width: 277px'" />
							</div>
						</div>
					</div>
					<!-- <div class="swiper-hexin-prev" id="prev" :style="{
						left:`30px`
					}" @click="prev()">
						<img src="@/assets/index/hxz.png" />
					</div>
					<div class="swiper-hexin-next" id="next" :style="{
						right:`30px`
					}" @click="next()">
						<img src="@/assets/index/hxy.png" />
					</div> -->
				</div>
				<!-- <div class="data17ImgListFor" v-for="(item,index) in spImgList" :key="index">
				<img :src="item.img" />
			</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				spImgList: [{
						img: require("@/assets/product/page6/img1.png")
					},
					{
						img: require("@/assets/product/page6/img2.png")
					},
					{
						img: require("@/assets/product/page6/img3.png")
					},
					{
						img: require("@/assets/product/page6/img4.png")
					},
				],
				activeIndex: 0,
				lista: [{
						img: require("@/assets/fgrs/A.jpg"),
						enTil: 'CBI-Amber',
						title: 'CBI-AMBER',
						titleTwo: '琥珀色模式',
						cen: '观测黏膜深层血管与浅层血水遮挡的出血点',
						name: '1',
						left: 0,
					},
					{
						img: require("@/assets/fgrs/D.jpg"),
						enTil: 'CBI-Indigo',
						title: 'CBI-INDIGO',
						titleTwo: '靓胭脂模式',
						cen: '有效提升黏膜与血管对比度',
						name: '2',
						left: 0,
					},
					{
						img: require("@/assets/fgrs/Q.jpg"),
						enTil: 'CBI-Aquar',
						title: 'CBI-AQUAR',
						titleTwo: '湖绿色模式',
						cen: '增加内镜下粘膜组织结构的可见性',
						name: '3',
						left: 0,
					},
					{
						img: require("@/assets/fgrs/R.jpg"),
						enTil: 'CBI-Regular',
						title: 'CBI-REGULAR',
						titleTwo: '常规模式',
						cen: '甄别粘膜层范围，突显黏膜下血管分布',
						name: '4',
						left: 0,
					},
				],
				itema: {},
				indexa: 0
			}
		},
		mounted() {
			let t = this;
			// const mySwiper = new this.$swiper('.swiper-data2-banner', {
			// 	// 方向
			// 	direction: 'horizontal',
			// 	// 自动播放
			// 	autoplay: false,
			// 	slidesPerView: 1,
			// 	on: {
			// 		slideChangeTransitionStart(e) {
			// 			t.activeIndex = this.activeIndex;
			// 		},

			// 	},
			// });
			let name = '.swiper-canpin' + this.list.index;
			const mySwiperTwo = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				slidesPerView: 'auto', // 每屏显示3个滑块
				slidesPerGroup: 1, // 每次滑动3个滑块
				spaceBetween: 30,
				freeMode: false,
				// 自动播放
				autoplay: false,
			});
			this.lista = JSON.parse(JSON.stringify(this.list.data.content));
			this.lista.map(v => {
				v.left = 0;
			})
			// this.mouseover(this.lista.length-1)
		},
		methods: {
			mouseout() {
				this.lista.map(v => {
					v.left = 0;
				})
				let index = this.indexa;
				this.itema = {};
				this.indexa = 0;
				// this.mouseover(index)
			},
			mouseover(e) {
				this.lista.map(v => {
					v.left = 0;
				})
				console.log(e)
				this.$nextTick(function() {
					this.lista.map((v, a) => {
						if (e > a) {
							v.left = 0;
						} else if (e < a) {
							if(this.headerShow){
								v.left = 80;
							}else{
								v.left =30;
							}
						}
					})
					this.indexa = e;
					this.itema = this.lista[e]
					console.log(this.lista)
				})

			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data17 {
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 150px;

		.data17Til {
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 40px;
		}

		.data17Cen {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #000000;
			margin-bottom: 40px;
		}

		.data17Img {
			width: 100%;
			height: 600px;
			margin-bottom: 40px;

			img {
				width: 100%;
				height: 100%;
			}

			video {
				width: 100%;
				height: 600px;
				object-fit: cover;
			}
		}

		.data17ImgList {
			display: flex;
			align-items: center;

			// overflow-x: auto;
			.swiper-canpin {
				width: 1200px;
				overflow: hidden;

				.swiper-slide-Two {
					width: 375px;
				}

				.swiper-slide-Two:not(:last-child) {
					margin-right: 31px;
				}
			}

			.data17ImgListFor:not(:last-child) {
				margin-right: 31px;
			}

			.data17ImgListFor {
				width: 375px;
				height: 230px;
				// cursor: pointer;
				position: relative;

				img {
					width: 375px;
					height: 230px;
				}
			}

		}
	}

	.swiper-data2-banner {
		overflow: hidden;
	}

	.swiper-slide {
		position: relative;

		img {
			width: 50vw;
			height: 600px;
			object-fit: cover;
		}

		video {
			width: 50vw;
			height: 600px;
		}
	}

	.dataImg {
		display: flex;
		justify-content: space-between;
		width: 1200px;
		height: 500px;
		background: #000;
		margin-bottom: 40px;
		overflow: hidden;

		.dataImgBox {
			// margin-left: 300px;
			position: relative;
			transform-style: preserve-3d;
			transform: perspective(1000px);
			background-color: #000;
			perspective: 1000px;
			transition: all .6s ease;
			height: 500px;

			// flex: 1;
			img {
				position: absolute;
				top: 50px;
				left: var(--img);
				transform-style: preserve-3d;
				transform: perspective(1000px) rotateY(30deg) scale(0.8);
				width: 350px;
				height: 350px;
				object-fit: cover;
				transition: all .6s ease;
				// cursor: pointer;
			}

			img:hover {
				transform: rotateY(15deg) scale(0.9);
				// z-index: 999;
			}

			.dataImgDw {
				position: absolute;
				top: 400px;
				left: var(--img);
				transition: all .6s ease;
				width: 300px;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;

				.dataImgDwXian {
					height: 50px;
					width: 2px;
					background-color: #fff;
					border-radius: 5px;
				}

				.dataImgDwWz {
					margin-top: 20px;
					color: #fff;
					white-space: nowrap;
					width: 300px;
					text-align: center;
				}
			}
		}

		.csBoxRight {
			// margin-right: -300px;
			width: 0;
			opacity: 0;
			height: 500px;
			display: flex;
			// align-items: center;
			color: #000;
			background-color: #fff;
			transition: all 0.6s ease;
			padding: 0 30px;
			flex-direction: column;

			.csBoxRightTitle {
				font-size: 42px;
				font-weight: bold;
				margin-bottom: 20px;
				width: 300px;
			}

			.csBoxRightTitleTwo {
				font-weight: bold;
				margin-bottom: 20px;
				text-align: left;
				font-size: 38px;
				width: 300px;
			}

			.csBoxRightCen {
				flex: 1;
				font-size: 18px;
				width: 300px;
			}

			.csBoxRightImg {
				width: 100%;
				margin-top: 50px;

				img {
					width: 100%;
					height: 200px;
					object-fit: cover;
				}
			}
		}
	}
	.swiper-canpin{
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
	}
	@media screen and (max-width:1200px) {
		.data17 {
			width: 100% !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;

			.data17Til {
				font-size: 24px !important;
				margin-bottom: 20px !important;
			}

			.data17Cen {
				font-size: 14px !important;
				margin-bottom: 20px !important;
			}

			.dataImg {
				width: 100% !important;
				margin-bottom: 20px !important;
				// overflow-x: auto !important;
				height: auto !important;

				// overflow-y: hidden !important;
				.dataImgBox {
					// margin-left: 0 !important;
					height: 200px !important;

					img {
						width: 150px !important;
						height: 100px !important;
						object-fit: contain;
					}
				}
			}

			.csBoxRight {
				// margin-right: -300px;
				width: 0;
				opacity: 0;
				display: flex;
				// align-items: center;
				color: #000;
				background-color: #fff;
				transition: all 0.6s ease;
				padding: 0px !important;
				flex-direction: column;

				.csBoxRightTitle {
					font-size: 24px;
					font-weight: bold;
					margin-bottom: 20px;
					width: 100%;
				}

				.csBoxRightTitleTwo {
					font-weight: bold;
					margin-bottom: 20px;
					text-align: left;
					font-size: 16px;
					width: 100%;
				}

				.csBoxRightCen {
					flex: 1;
					font-size: 14px;
					width: 100%;
				}

				.csBoxRightImg {
					width: 100%;
					margin-top: 50px;

					img {
						width: 100%;
						height: 200px;
						object-fit: contain;
					}
				}

			}
		}

		.swiper-canpin {
			width: 100% !important;

			.swiper-slide-Two {
				width: 100px !important;
				margin-right: 0px !important;
			}
		}

		.data17ImgListFor {
			height: calc(20vh - 70px) !important;

			img {
				width: 100px !important;
				height: 100% !important;
				object-fit: contain !important;
			}
		}
		.swiper-canpin{
			.swiper-hexin-prev{
				display: block;
			}
			.swiper-hexin-next{
				display: block;
			}
			.swiper-hexin-prev {
				position: absolute;
				top: 50%;
				left: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				transform: translateY(-50%);
				transition: all 0.3s ease;
			}
			
			.swiper-hexin-next {
				transform: translateY(-50%);
				position: absolute;
				top: 50%;
				right: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			}
		}
	}
</style>